import { Slide } from "@material-ui/core";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function SlideTransitionComponent(props: any) {
  const { direction } = props;

  return <Slide {...props} direction={direction || "up"} />;
}
export default SlideTransitionComponent;
